import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { RoutesService } from "../Services";
import UserListner from "../UserServices/UserListner"; // Import the UserListner
import userServices from "../UserServices/UserServices";
import { Row, Spin } from "antd";

const ProtectedRoute = ({ component: Component, allowedRoles, ...props }) => {
	const navigate = useNavigate();

	const [currentUser, setCurrentUser] = useState(undefined);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const checkUserValidity = async () => {
			const isValid = await userServices.checkIFValid(); // If async, await this.
			if (isValid) {
				const user = await userServices.getCurrentUser(); // Ensure this is awaited if async.
				if (user?.role) {
					setCurrentUser(user);
				} else {
					navigate(RoutesService.getLoginRoute());
				}
			} else {
				navigate(RoutesService.getLoginRoute());
			}
			setLoading(false);
		};

		checkUserValidity();
	}, [navigate]);

	// Loading spinner
	if (loading) {
		return (
			<Row justify="center" align="middle" style={{ height: "100vh" }}>
				<Spin size="large" />
			</Row>
		);
	}

	// Redirect to login if no user
	if (!currentUser) {
		return <Navigate to={RoutesService.getLoginRoute()} />;
	}

	// Redirect if the user doesn't have the required role
	if (!allowedRoles.includes(currentUser.role)) {
		return <Navigate to={RoutesService.getLoginRoute()} />;
	}

	// Render the protected component with UserListner
	return (
		<UserListner>
			<Component {...props} />
		</UserListner>
	);
};

export default ProtectedRoute;
